import script from "./UserProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserProfile.vue?vue&type=script&lang=ts&setup=true"

import "./UserProfile.vue?vue&type=style&index=0&id=ecdef756&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecdef756"]])

export default __exports__